import React from 'react';
import { PropTypes } from 'prop-types';
import { TextField } from '@material-ui/core';
import classNames from 'classnames';
import { useActiveFilterClasses } from '../molecules/activeFilter.styles';

export const FormField = ({ component: Component = TextField, errors, active, className, ...otherProps }) => {
  const { activeFilter } = useActiveFilterClasses();
  const normalizedPros = { ...otherProps };

  if (errors) {
    normalizedPros.helperText = errors;
    normalizedPros.error = true;
  }

  normalizedPros.className = classNames(className, { [activeFilter]: active });

  return <Component {...normalizedPros} />;
};

FormField.propTypes = {
  component: PropTypes.elementType,
  errors: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  active: PropTypes.bool,
  className: PropTypes.string
};
